<template>
  <div :id="positionId" class="cio-banner" data-testid="customerio-banner"></div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { CUSTOMERIO_POSITIONS } from "@/types/customerio";

/**
 * Anchor for a Customer.io inline in-app message.
 *
 * Customer.io replaces the contents of the element whose id matches the
 * campaign's Position ID when a campaign is active, and leaves it empty
 * otherwise — so nothing is shown when no campaign is running. Per Customer.io
 * guidance we intentionally avoid setting a fixed height on the position
 * element; the SDK sizes it to the creative (328x72 for the payment banner).
 */
export default defineComponent({
  name: "CustomerioBanner",
  props: {
    positionId: {
      type: String,
      default: CUSTOMERIO_POSITIONS.installmentsList,
    },
  },
});
</script>

<style scoped>
/* Keep the position element in normal flow at all times (no display:none / size
   constraints) so Customer.io's inline renderer can always find and populate it
   — see Customer.io's guidance to avoid constraining the position element. When
   empty it naturally collapses to 0 height, so nothing shows; spacing + shadow
   are only applied once a campaign has populated it. */
.cio-banner {
  width: 100%;
}

.cio-banner:not(:empty) {
  margin-top: 16px;
}
</style>
